import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SearchTitleGraphqlFragmentDoc } from '../fragments/SearchTitle.fragment';
export type GetSearchTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	first?: Types.Scalars['Int']['input'];
	language: Types.Scalars['Language']['input'];
	searchAfterCursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
	searchTitlesFilter?: Types.InputMaybe<Types.TitleFilter>;
	searchTitlesSortBy?: Types.PopularTitlesSorting;
	sortRandomSeed?: Types.Scalars['Int']['input'];
	location: Types.Scalars['String']['input'];
}>;

export type GetSearchTitlesQuery = {
	__typename?: 'Query';
	searchTitles: {
		__typename?: 'TitleSearchResult';
		totalCount: number;
		edges: Array<{
			__typename?: 'TitleSearchResultEdge';
			cursor: string;
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							posterUrl?: string | null;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
								jwRating?: number | null;
								tomatoMeter?: number | null;
								certifiedFresh?: boolean | null;
								hideJWRating: boolean;
							};
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
						} | null;
						offers: Array<{
							__typename?: 'Offer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							id: string;
							package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
						}>;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							posterUrl?: string | null;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
								jwRating?: number | null;
								tomatoMeter?: number | null;
								certifiedFresh?: boolean | null;
								hideJWRating: boolean;
							};
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
						};
						watchNowOffer?: {
							__typename?: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
						} | null;
						offers: Array<{
							__typename?: 'Offer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							id: string;
							package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
						}>;
				  };
		}>;
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
	};
};

export const GetSearchTitlesDocument = gql`
	query GetSearchTitles(
		$country: Country!
		$first: Int! = 5
		$language: Language!
		$searchAfterCursor: String
		$searchTitlesFilter: TitleFilter
		$searchTitlesSortBy: PopularTitlesSorting! = POPULAR
		$sortRandomSeed: Int! = 0
		$location: String!
	) {
		searchTitles(
			after: $searchAfterCursor
			country: $country
			filter: $searchTitlesFilter
			first: $first
			sortBy: $searchTitlesSortBy
			sortRandomSeed: $sortRandomSeed
			source: $location
		) {
			edges {
				...SearchTitleGraphql
			}
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			totalCount
		}
	}
	${SearchTitleGraphqlFragmentDoc}
`;
